import React, { useState } from 'react';
import { Layout, Button } from 'antd';
import { API_URL } from "../constant";
const { Sider, Content } = Layout;

const LayoutStyle: React.CSSProperties = {
  height: 'calc(100vh - 145px)',
};

const siderStyle: React.CSSProperties = {
  textAlign: 'center',
  backgroundColor: '#333',
  padding: '10px',
};

const buttonStyle: React.CSSProperties = {
  width: '100%',
  marginBottom: '5px',
  backgroundColor: '#333',
  color: 'white',
  border: 'none',
};

const selectedButtonStyle: React.CSSProperties = {
  ...buttonStyle,
  opacity: 0.7,
  fontWeight: 'bold',
};

const contentStyle: React.CSSProperties = {
  color: '#333',
  flex: '1',
  minHeight: '100px',
  overflowY: 'auto',
};

const Home: React.FC = () => {
  const [iframeSrc, setIframeSrc] = useState<string>(`${API_URL}news.html?_=${Date.now()}`);
  const [selected, setSelected] = useState<string>(`${API_URL}news.html`);
  const menuItems = [
    { label: 'News & FAQ', url: `${API_URL}news.html` },
    { label: 'Bulletins', url: `${API_URL}bulletin.html` },
    // { label: 'Filing Statistics', url: `${API_URL}stats.html` },
    { label: 'Class Codes', url: `${API_URL}class_codes.html` },
    { label: 'Qualified Carriers', url: `${API_URL}carriers.html` },
    { label: 'Form & Instructions', url: `${API_URL}forms.html` },
    { label: 'Excel Form', url: `${API_URL}excel_forms.html` },
    { label: 'Webinars - Training', url: `${API_URL}webinars.html` },
    { label: 'NRRA - Important', url: `${API_URL}nrra.html` },
    { label: 'Industry Links', url: `${API_URL}industry_links.html` },
  ];

  return (
    <div style={{ height: '100%' }}>
      <Layout style={LayoutStyle}>
        <Sider width="300px" style={siderStyle} className='bg-gradient-to-b from-zinc-300 to-gray-100'>
          {menuItems.map((item, index) => (
            <Button
              key={index}
              style={selected === item.url ? selectedButtonStyle : buttonStyle}
              onClick={() => {
                console.log(item.url);
                setIframeSrc(item.url+"?_="+Date.now());
                setSelected(item.url);
              }}
            >
              {item.label}
            </Button>
          ))}
          <div className='mt-10'>
            <iframe
              src={"html/aboutus.html?_="+Date.now()}
              style={{ width: '100%', height: '250px', border: 'none', overflow: 'hidden' }}
            ></iframe>
          </div>
        </Sider>
        <Content style={contentStyle} className='bg-gradient-to-b from-zinc-300 to-zinc-100'>
          <iframe src={iframeSrc} style={{ width: '100%', height: '100%', border: 'none' }}></iframe>
        </Content>
      </Layout>
    </div>
  );
};

export default Home;
